import {
    OBTENER_VARIABLES
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_VARIABLES:
            return {
                ...state,
                variablesModelo: action.payload,
            }
        
        default:
            return state;
    }
}